import useStyles from "./MessageInfoStyle";

export default function MessageInfo() {
  const classes = useStyles();

  return (
    <div className={classes.text}>
      We're excited to announce that the latest version of RRS has been published on March 17, 2024. Your feedback is
      invaluable to us, so please don't hesitate to share your comments and suggestions to assistant@rhinology.org
    </div>
  );
}
